import Diagnose from '@/types/Diagnose';
import {Satzart} from '@/types/Satzart';

export default class PatDiagnose {
    /** PK | erforderlich */
    public patdiagnose_id: number | null = null;
    /** FK: Patient Verweis auf Tab. Patienten | erforderlich */
    public patnr: number | null = null;
    /** Datum */
    public diagnosedatum: string | null = null;
    /**  j/n | max. 1 Zeichen */
    public hauptdiagnose: string | null = null;
    /** Verweis auf Datensatz mit der Hauptdiagnose */
    public haupt_patdiagnose_id: number | null = null;
    /** Verweis auf Tab. Diagnosen */
    public diagnose_id: number | null = null;
    /** Diagnose als Text (Altdaten) | max. 40 Zeichen */
    public diagnose: string | null = null;
    /** j/n | max. 1 Zeichen */
    public chronisch: string | null = null;
    /**  max. 50 Zeichen  */
    public bemerkungen: string | null = null;
    /**  max. 6 Zeichen */
    public immunsupression: string | null = null;
    public patdiagnose: string | null = null;
    public nebendiagnosen: any[] = [];
    public satzart: number | null = Satzart.Diagnose;


    constructor(data?: Partial<PatDiagnose>) {
        Object.assign(this, data);
    }
}
